export default __webpack_public_path__ + "static/media/client.41abc349.png";